var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaymentsIcon = function SvgPaymentsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/ecommerce/outline/money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 826",
    d: "M1.33331 5.33332C1.33331 3.86056 2.52722 2.66666 3.99998 2.66666H12C13.4727 2.66666 14.6666 3.86056 14.6666 5.33332V10.6667C14.6666 12.1394 13.4727 13.3333 12 13.3333H3.99998C2.52722 13.3333 1.33331 12.1394 1.33331 10.6667V5.33332Z",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 677",
    d: "M9.33335 7.99999C9.33335 8.73637 8.7364 9.33332 8.00002 9.33332C7.26364 9.33332 6.66669 8.73637 6.66669 7.99999C6.66669 7.26361 7.26364 6.66666 8.00002 6.66666C8.7364 6.66666 9.33335 7.26361 9.33335 7.99999Z",
    stroke: "#595959",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 681",
    d: "M4.33333 5.00001C4.33333 5.3682 4.03486 5.66668 3.66667 5.66668C3.29848 5.66668 3 5.3682 3 5.00001C3 4.63182 3.29848 4.33334 3.66667 4.33334C4.03486 4.33334 4.33333 4.63182 4.33333 5.00001Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 682",
    d: "M13 5.00001C13 5.3682 12.7015 5.66668 12.3334 5.66668C11.9652 5.66668 11.6667 5.3682 11.6667 5.00001C11.6667 4.63182 11.9652 4.33334 12.3334 4.33334C12.7015 4.33334 13 4.63182 13 5.00001Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 683",
    d: "M4.33333 11C4.33333 11.3682 4.03486 11.6667 3.66667 11.6667C3.29848 11.6667 3 11.3682 3 11C3 10.6318 3.29848 10.3333 3.66667 10.3333C4.03486 10.3333 4.33333 10.6318 4.33333 11Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 684",
    d: "M13 11C13 11.3682 12.7015 11.6667 12.3334 11.6667C11.9652 11.6667 11.6667 11.3682 11.6667 11C11.6667 10.6318 11.9652 10.3333 12.3334 10.3333C12.7015 10.3333 13 10.6318 13 11Z",
    fill: "#595959"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "paymentsIcon.2771534717569228657e1ed1105a2002.svg";